export default class OpenCashier {
    constructor() {
        this.user = { id: "", content: "" };
        this.openValue = 0;
        this.typePayment = { id: "", content: "" };
        this.observation = "";
        this.type = 1;
    }
}